<div class="content-container top">
  <div class="card-content-outer nandor">
    <div class="challenge-course-nav">
      <a
        id="w-node-_7b6f9696-b21f-ffef-1737-cd711b6756bb-d3dddc7a"
        href="https://www.curbnturf.com"
        class="cnt-home w-inline-block"
      >
        <img
          src="/img/CNT_Logo_V_White.svg"
          loading="lazy"
          id="w-node-c03396e8-44a8-4f6a-a69c-13169dbb7f36-d3dddc7a"
          alt="CurbNTurf Logo"
          class="cnt-logo"
        />
      </a>
      <div class="nav-button-wrapper">
        <a *ngIf="position" [routerLink]="['', 'course']" class="nav-link-hero nav w-inline-block">
          <div class="login-wrapper">
            <div>Agritourism Challenge Course</div>
          </div>
        </a>
        <a *ngIf="position > 1" [routerLink]="['', 'course', 'day-' + (position - 1)]" class="nav-link-hero nav w-inline-block">
          <div class="login-wrapper">
            <div>Previous Lesson</div>
          </div>
        </a>
        <a *ngIf="position < 5" [routerLink]="['', 'course', 'day-' + (position + 1)]" class="nav-link-hero nav w-inline-block">
          <div class="login-wrapper">
            <div>Next Lesson</div>
          </div>
        </a>
        <a *ngIf="!user?.id" [routerLink]="['', 'auth', 'login']" class="nav-link-hero nav w-inline-block">
          <div class="login-wrapper">
            <div class="icon-login">
              <div class="w-embed">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M12 14C14.2091 14 16 12.2091 16 10C16 7.79086 14.2091 6 12 6C9.79086 6 8 7.79086 8 10C8 12.2091 9.79086 14 12 14ZM12 12C13.1046 12 14 11.1046 14 10C14 8.89543 13.1046 8 12 8C10.8954 8 10 8.89543 10 10C10 11.1046 10.8954 12 12 12Z"
                    fill="currentColor"
                  ></path>
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M17.9261 20.0557C20.397 18.235 22 15.3047 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 15.3047 3.60301 18.235 6.07388 20.0557C6.11934 20.0892 6.16509 20.1223 6.21112 20.1551C6.65997 20.4742 7.1363 20.7573 7.63587 21C8.95464 21.6407 10.4354 22 12 22C13.5646 22 15.0454 21.6407 16.3641 21C16.3909 20.987 16.4177 20.9738 16.4443 20.9606C16.9657 20.7015 17.4613 20.3982 17.9261 20.0557ZM17.2287 18.055C18.926 16.588 20 14.4194 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 14.4194 5.07401 16.588 6.77128 18.055C7.80066 16.2313 9.75654 15 12 15C14.2435 15 16.1993 16.2313 17.2287 18.055ZM15.5567 19.1679C14.8921 17.8803 13.5488 17 12 17C10.4512 17 9.10792 17.8803 8.44332 19.1679C9.51467 19.7005 10.7224 20 12 20C13.2776 20 14.4853 19.7005 15.5567 19.1679Z"
                    fill="currentColor"
                  ></path>
                </svg>
              </div>
            </div>
            <div>Log in</div>
          </div>
        </a>
        <a *ngIf="user?.id" [routerLink]="['', 'auth', 'logout']" class="nav-link-hero nav w-inline-block">
          <div class="login-wrapper">
            <div *ngIf="user.photo?.key" class="icon-login">
              <img
                class="menu-user-image rounded-circle"
                [src]="getPhotoUrl(user.photo)"
                alt="{{ user.firstName }} {{ user.lastName }}"
              />
            </div>
            <div>Log out</div>
          </div>
        </a>
      </div>
    </div>
  </div>
</div>
